<div class="container-rating">
    <div class="headline-rating is-flex p-3 border-radius has-background-secondary has-text-white">
        <div><b>Produktbewertung</b></div>
        <div class="is-flex-grow-1 has-text-right">
            @if (!(customer$ | async)?.id) {
                <a #targetEl (click)="op.toggle($event, targetEl)"><b>Bewertung abgeben ></b></a>
            }
            @if ((customer$ | async)?.id && !disableRating) {
                <a (click)="showModalRating = true"><b>Bewertung abgeben ></b></a>
            }

            <p-popover #op>
                <p>Bitte loggen Sie sich ein, um eine Bewertung abzugeben.</p>
            </p-popover>
        </div>
    </div>
    @for (item of articleRatings; track item.id) {
        <div class="container-rating-item">

            <div class="headline-rating is-flex p-3 mt-4 has-background-grey-lighter">

                <div class="is-flex stars ml-1 has-text-left">
                    <div class="is-white-space-nowrap">
                        @for (star of [1, 2, 3, 4, 5]; track star) {
                            <fa-icon
                                    [icon]="item.rating >= star ? faStarSolid : faStarRegular"
                                    role="img"
                                    [attr.aria-label]="'Bewertung ' + star + ' von 5 Sternen'">
                            </fa-icon>
                        }
                    </div>
                </div>

                @if (item.username) {
                    <div class="has-text-left ml-2">{{ item.username }}</div>
                }

                <div class="is-flex-grow-1 has-text-right mr-auto">
                    {{ item.dateCreated | date:'dd.MM.yyyy HH:mm' }}
                </div>
            </div>

            @if (item.comment) {
                <div class="content-rating p-4">
                    {{ item.comment }}
                </div>
            }

        </div>
    } @empty {
        <div class="p-4 has-text-centered has-text-grey">
            Noch keine Bewertungen vorhanden.
        </div>
    }
</div>
@if (showModalRating) {
    <div class="modal is-active">
        <div class="modal-background"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">Bewertung abgeben</p>
                <button class="delete" (click)="showModalRating = false"></button>
            </header>
            <section [formGroup]="form" class="modal-card-body">
                @if (formStatus == 'success') {
                    <div>
                        <h1 class="title">Vielen Dank.</h1>
                        <p class="subtitle">Ihre Bewertung wurde erfolgreich erfasst. </p>
                    </div>
                }
                @if (formStatus != 'success') {
                    <div>
                        @if (apiError) {
                            <article class="message is-danger">
                                <div class="message-body">
                                    <b>{{ apiError.notification }}</b>
                                    @for (error of apiError.errors; track $index) {
                                        <span class="is-block">
                                        @if (error.key !== 'email') {
                                            <span>{{ error.key }}:</span>
                                        }
                                            {{ error.error }}
                                      </span>
                                    }
                                </div>
                            </article>
                        }

                        <div class="field">
                            <div class="select">
                                <select formControlName="rating">
                                    <option value="">Bewertung auswählen</option>
                                    <option [value]="1">1 Stern</option>
                                    <option [value]="2">2 Sterne</option>
                                    <option [value]="3">3 Sterne</option>
                                    <option [value]="4">4 Sterne</option>
                                    <option [value]="5">5 Sterne</option>
                                </select>
                                @if (isFormRequestError('rating')) {
                                    <p class="help is-danger">Bitte hinterlegen Sie eine Bewertung.</p>
                                }
                            </div>
                        </div>
                        <div class="field">
                            <div class="control">
                                <input formControlName="username" class="input" type="text"
                                       placeholder="Angezeigter Name">
                                @if (isFormRequestError('username')) {
                                    <p class="help is-danger">Bitte hinterlegen Sie einen Namen.</p>
                                }

                            </div>
                        </div>
                        <div class="field">
                            <textarea formControlName="comment" class="textarea" placeholder="Nachricht"></textarea>
                        </div>
                        <div class="mt-4">
                            <iw-shop-forms-submit-button [formStatus]="formStatus" submitLabel="Absenden"
                                                         (submit)="submit()"></iw-shop-forms-submit-button>
                        </div>
                    </div>
                }
            </section>
        </div>
    </div>
}

